(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvVerticalDivider', drvVerticalDivider);

    drvVerticalDivider.$inject = [];

    /**
     * Vertical Divider used throughout ChilliDocs
     */
    function drvVerticalDivider() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: function () {},
            template:
                '<span style="display: block; margin-left: 6px; margin-right: 5px; border-right-width: 1px; border-right-style: solid; height: 30px;">' +
                '</span>'
        };
        return directive;
    }
})();